import React from 'react';
import useCountUp from '../hooks/useCountUp';
import { PROOF, FOUNDED } from '../content/proof';
import { Section, Eyebrow } from './ui';

const Stat = ({ value, suffix, label, note, display, href }) => {
  const { countRef, displayValue } = useCountUp({ end: value });
  const shown = display ? (displayValue === value ? display : display.replace(/\d+/, displayValue)) : `${displayValue}${suffix}`;
  return (
    <div className="rounded-lg border border-navy-200 bg-white p-4 sm:p-5 dark:bg-navy-850 dark:border-navy-700 [&:last-child:nth-child(odd)]:col-span-2 sm:[&:last-child:nth-child(odd)]:col-span-1 lg:[&:last-child:nth-child(odd)]:col-span-1">
      <div ref={countRef} className="font-sans font-semibold text-stat-lg text-navy-800 dark:text-white tabular-nums" aria-label={`${display || value + suffix} ${label}`}>
        {shown}
      </div>
      <div className="font-sans text-interface font-medium mt-2 text-navy-800 dark:text-white">{label}</div>
      {note && <div className="font-sans text-small mt-1 text-navy-500 dark:text-navy-400">{note}</div>}
      {href && <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center min-h-[32px] mt-1 font-sans text-interface font-medium text-emerald-600 dark:text-emerald-300">The list</a>}
    </div>
  );
};

/** Year one, in numbers. Real values are in the HTML; the count is decoration. */
const ProofBand = () => (
  <Section tone="page" id="year-one" className="!pt-6 md:!pt-8 !pb-12 md:!pb-14">
    <div className="border-t border-navy-200 dark:border-navy-700 pt-8 mb-6 flex flex-wrap items-baseline gap-x-6 gap-y-2">
      <Eyebrow className="!mb-0">Year one</Eyebrow>
      <p className="font-sans text-interface text-navy-600 dark:text-[#C9D2E0]">Founded {FOUNDED}. What the first year built.</p>
    </div>
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-[10px] sm:gap-[14px]">
      {PROOF.map((p) => <Stat key={p.label} {...p} />)}
    </div>
  </Section>
);

export default ProofBand;
